<div style="max-width: 100%;">
    <div class="modal-header" style="height: 8px; " id="modalgreen">
        <a class="close" (click)="activeModal.close('close')" title="Close">×</a>
    </div>
    <div style="overflow-y:scroll;height:500px">
    <div class="d-flex justify-content-center">
        <div class="col-md-12">

        </div>
    </div>
    <table style="margin-top: 5px;" id="currentSelectTable" cellspacing="0" cellpadding="2" width="125%">
        <tbody>
            <tr>
            </tr>
            <tr>
                <td width="40%" align="center">

                    <span style="color: black; font-size: 16px;">
                        <div class="d-flex justify-content-center">
                            <pagination-controls (pageChange)="pageChanged($event);q=$event"></pagination-controls>
                        </div>
                    </span>
                </td>
                <td width="60%" align="center">
                    <div style="margin-top: 23px;">
                        <h4>{{'Date'|translate}}: </h4>
                    </div>
                    <input class="option-date" type="text" id="sessionDate" value=""><br>
                    <div class="grid__item three-twelfths" style="margin-top: 23px;">
                        <h4>{{'State'|translate}}: </h4>
                    </div>
                    <select class="dropdown" id="sessionStateFilter">

                        <option value="">{{'None'|translate}}</option>
                        <!-- Messy -->


                        1

                        <option value="1">
                            {{'Qualifying vehicle'|translate}}
                        </option>


                        2

                        <option value="2">
                            {{'Viewing diagnostic summary'|translate}}
                        </option>


                        19

                        <option value="19">
                            {{'Running diagnostic'|translate}}
                        </option>


                        3

                        <option value="3">
                            {{'Running toolbox'|translate}}
                        </option>


                        30

                        <option value="30">
                            {{'Service Reception closed'|translate}}
                        </option>


                        5

                        <option value="5">
                            {{'Selecting symptoms'|translate}}
                        </option>


                        4

                        <option value="4">
                            {{'Loading diagnostic candidates'|translate}}
                        </option>


                        6

                        <option value="6">
                            {{'Viewing diagnostic candidates'|translate}}
                        </option>


                        7

                        <option value="7">
                            {{'Running SPA diagnostic'|translate}}
                        </option>


                        8

                        <option value="8">
                            {{'Viewing Etis diagnostic page'|translate}}
                        </option>


                        17

                        <option value="17">
                            {{'MANUAL DIAGNOSIS'|translate}}
                        </option>


                        100

                        <option value="100">
                            {{'Processing repair and post repair instructions'|translate}}
                        </option>


                        20

                        <option value="20">
                            {{'Entering Warranty Dealer code'|translate}}
                        </option>


                        22

                        <option value="22">
                            {{'Requesting technical hotline check'|translate}}
                        </option>


                        60

                        <option value="60">
                            {{'Entering hotline repair validation code'|translate}}
                        </option>


                        21

                        <option value="21">
                            {{'Displaying repair validation code'|translate}}
                        </option>


                        10

                        <option value="10">
                            {{'Viewing repair instructions'|translate}}
                        </option>


                        11

                        <option value="11">
                            {{'Running SPA repair instruction'|translate}}
                        </option>


                        341

                        <option value="341">
                            {{'Running OTX repair instruction'|translate}}
                        </option>


                        12

                        <option value="12">
                            {{'Viewing FordETIS repair instruction'|translate}}
                        </option>


                        14

                        <option value="14">
                            {{'Viewing post repair instructions'|translate}}
                        </option>


                        15

                        <option value="15">
                            {{'Running SPA post repair instruction'|translate}}
                        </option>


                        16

                        <option value="16">
                            {{'Viewing FordETIS post repair instruction'|translate}}
                        </option>


                        221

                        <option value="221">
                            {{'Running OTX post repair instruction'|translate}}
                        </option>


                        18

                        <option value="18">
                            {{'Repair completed'|translate}}
                        </option>


                        401

                        <option value="401">
                            {{'Repair qualification'|translate}}
                        </option>


                        421

                        <option value="421">
                            {{'Running OTX diagnostic candidate'|translate}}
                        </option>


                        40

                        <option value="40">
                            {{'Displaying toolbox menu'|translate}}
                        </option>


                        80

                        <option value="80">
                            {{'Toolbox invoked'|translate}}
                        </option>


                        551

                        <option value="551">
                            {{'Assistance Needed'|translate}}
                        </option>

                    </select>
                    <button class="previous-next" type="button" id="filterButton" (click)="filterData()"
                        value="Filter" style="margin-bottom:20px;">{{'FILTER'|translate}}</button>
                </td>
            </tr>
            <tr>
                <td colspan="2" style="padding:15px">
                    <table style="width:100%;">
                        <tbody>
                            <tr>
                                <th
                                    style="background-color: #003F87; color: #FFFFFF; padding: 15px; font-weight: 900; text-align: left;">
                                    {{'Date'|translate}}</th>
                                <th
                                    style="background-color: #003F87; color: #FFFFFF; padding: 15px; font-weight: 900; text-align: left;">
                                    {{'Start Time'|translate}}</th>
                                <th
                                    style="background-color: #003F87; color: #FFFFFF; padding: 15px; font-weight: 900; text-align: left;">
                                    {{'Dealer Code'|translate}}</th>
                                <th
                                    style="background-color: #003F87; color: #FFFFFF; padding: 15px; font-weight: 900; text-align: left;">
                                    {{'Technician'|translate}}</th>
                                <th
                                    style="background-color: #003F87; color: #FFFFFF; padding: 15px; font-weight: 900; text-align: left;">
                                    {{'State'|translate}}</th>
                                <th
                                    style="background-color: #003F87; color: #FFFFFF; padding: 15px; font-weight: 900; text-align: left;">
                                    {{'RVC'|translate}}</th>
                                <th
                                    style="background-color: #003F87; color: #FFFFFF; padding: 15px; font-weight: 900; text-align: left;">
                                    &nbsp;</th>
                                <th
                                    style="background-color: #003F87; color: #FFFFFF; padding: 15px; font-weight: 900; text-align: left;">
                                    {{'Method'|translate}}</th>
                                <th
                                    style="background-color: #003F87; color: #FFFFFF; padding: 15px; font-weight: 900; text-align: left;">
                                    &nbsp;</th>
                            </tr>
                            <tr *ngFor="let item of collection1|hotlinefilter:dateStateFilter|paginate:{
                    itemsPerPage: 3,
                    currentPage: q,
                    totalItems: collection1.length
                  }">
                                <td style="padding:10px;">{{item.date}}</td>
                                <td style="padding:10px;">{{item.starttime}}</td>
                                <td style="padding:10px;">{{item.technician}} </td>
                                <td style="padding:10px;">{{item.dealercode}}</td>
                                <td style="padding:10px;">{{item.state}}</td>
                                <td style="padding:10px;">{{item.rvc}}</td>
                                <td style="padding:10px;"></td>
                                <td style="padding:10px;">
                                    <button class="previous-next mr-3" type="button"
                                        style="margin-bottom: 15px; margin-right: 15px;">{{'View'|translate}}</button>
                                </td>
                                <td style="padding:10px;"><button class="previous-next mr-3" type="button"
                                        name="selectedVehicle"
                                        style="margin-bottom: 15px; margin-right: 15px;">{{'SELECT'|translate}}</button>
                                </td>

                            </tr>







                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>

    <div class="modal-footer" id="modalblue">
        <button type="button" class="btn btn-primary mr-3 shadow-none"
            (click)="activeModal.close('close')">{{'Close'|translate}}</button>
    </div>
</div>
</div>